<script setup>
import github from "@/assets/img/github.svg";
import google from "@/assets/img/google.svg";
import Navbar from "@/components/Navbars/AuthNavbar.vue";
import FooterSmall from "@/components/Footers/FooterSmall.vue";
import registerBg2 from "@/assets/img/register_bg_2.png";
import {ElLoading} from "element-plus";
import {ref} from "vue";
import {inject} from 'vue'
import {ElMessage} from "element-plus";
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";

const $axios = inject('$axios')


function download(filename) {
  const loadingInstance = ElLoading.service({
    fullscreen: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)',
    lock: true
  })
  $axios({
    url: `http://bioinfo-sysu.com:8002/api/download`,
    method: 'post',
    params: {
      file: filename,
    },
    responseType: 'blob' // 表明返回服务器返回的数据类型
  }).then(resp => {
    loadingInstance.close()
    var res = JSON.parse(JSON.stringify(resp.headers))
    if (res['content-type'] === 'application/zip') {
      let url = window.URL.createObjectURL(new Blob([resp.data], {type: "application/zip;charset=utf-8"}));
      const link = document.createElement("a");
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      console.log(url)
    } else {
      loadingInstance.close()
      ElMessage({
        dangerouslyUseHTMLString: true,
        showClose: true,
        message: '<p>Sorry,Some samples are missing corresponding data.</p>',
        type: 'error',
        center: true,
      })
    }
  })

}
</script>
<template>
  <div>
    <index-navbar/>
    <main>
      <section class="relative w-full h-full py-40 min-h-screen">
        <div
            class="absolute top-0 w-full h-full  bg-no-repeat bg-full"
        ></div>
        <div class="container mx-auto px-4 h-full">
          <div class="flex content-center items-center justify-center h-full">
            <div class="w-full lg:w-12/12 px-4">
              <div
                  class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg  border-0"
              >
                <div class="rounded-t mb-0 px-6 py-6">

                  <div class="text-center my-3">
              <span class="text-blueGray-500 text-lg font-bold" style="font-size:35px">
                Download
              </span>
                  </div>
                  <div class="col-12">
                    <table class="table table-striped table-md align-middle mt-4"
                           style="text-align: center;table-layout:fixed">
                      <tbody>
                      <tr>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 30%">
                          Genome
                        </td>
<!--                        <td style="white-space:inherit;width: 40%">-->
<!--                          Contains detailed information on all A-to-I RNA editing sites-->
<!--                        </td>-->
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 30%">
                          <a href="https://www.ncbi.nlm.nih.gov/datasets/genome/GCF_003789085.1/" target="_blank">
                            <button
                                class="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                type="button">
                              Downloading
                            </button>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 30%">
                          NCBI Annotations
                        </td>
<!--                        <td style="white-space:inherit;width: 40%">-->
<!--                          Includes comprehensive data on all C-to-U RNA editing sites-->
<!--                        </td>-->
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 30%">
                          <a href="https://www.ncbi.nlm.nih.gov/datasets/gene/GCF_003789085.1/" target="_blank">
                            <button
                                class="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                type="button">
                              Downloading
                            </button>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 30%">
                          GTF Annotation File (Complete)
                        </td>
<!--                        <td style="white-space:inherit;width: 40%">-->
<!--                          Contains information on the relationship between editing levels of A-to-I sites in various-->
<!--                          organs and age-->
<!--                        </td>-->
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 30%">
                          <a href="https://zenodo.org/records/17882379/files/assembly_new.gtf?download=1" target="_blank">
                            <button
                                class="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                type="button">
                              Downloading
                            </button>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 70%">
                          GMT File
                        </td>
<!--                        <td style="white-space:inherit;width: 40%">-->
<!--                          Includes the corresponding GTEx Sample Information-->
<!--                        </td>-->
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 30%">
                          <a href="https://zenodo.org/records/17882379/files/GO.gmt?download=1"
                             target="_blank">
                            <button
                                class="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                type="button">
                              Downloading
                            </button>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 70%">
                          Bulk RNA-seq Expression Matrix
                        </td>
<!--                        <td style="white-space:inherit;width: 40%">-->
<!--                          The distribution of RNA editing sites across various cell types in peripheral blood-->
<!--                        </td>-->
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 30%">
                          <a href="https://zenodo.org/records/17882379/files/bulk-exp-matrix.xlsx?download=1"
                             target="_blank">
                          <button
                              class="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                              type="button">
                            Downloading
                          </button>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 70%">
                          Bulk RNA-seq Sample Information
                        </td>
<!--                        <td style="white-space:inherit;width: 40%">-->
<!--                          The distribution of RNA editing sites across various cell types in peripheral blood-->
<!--                        </td>-->
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 30%">
                          <a href="https://zenodo.org/records/14943885/files/GSE157007_edit_data.csv?download=1"
                             target="_blank">
                          <button
                              class="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                              type="button">
                            Downloading
                          </button>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 70%">
                          Single-cell RNA-seq File
                        </td>
<!--                        <td style="white-space:inherit;width: 40%">-->
<!--                          The distribution of RNA editing sites across various cell types in peripheral blood-->
<!--                        </td>-->
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;width: 30%">
                          <a href="https://www.ncbi.nlm.nih.gov/bioproject/?term=PRJNA1392667"
                             target="_blank">
                          <button
                              class="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                              type="button">
                            Downloading
                          </button>
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer-component/>
    </main>
  </div>
</template>
